import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import {
	Link
} from '@mui/material';

import { DataTable, CircularProgressWithLabel } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const ActivityDataTable = (props) => {
	const { className, data, openActivityDetails, ...rest } = props;
	const classes = useStyles();

	const _getTableColumns = () => (
		[
			{
				name: 'activityId',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'activityName',
				label: 'Activity',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => {
						const { rowData } = tableMeta;
						return (
							<Link
								component="button"
								variant="body2"
								onClick={
									() => { openActivityDetails(rowData[0]); }
								}
								underline="hover"
							>
								{value}
							</Link>
						);
					}
				}
			},
			{
				name: 'completion',
				label: 'Completion',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => (
						<CircularProgressWithLabel value={value} />
					)
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false, // Try Adding This
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="ActivityDataTable"
				title="All Activities"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
		</div>
	);
};

ActivityDataTable.propTypes = {
	className: PropTypes.object,
	data: PropTypes.array,
	openActivityDetails: PropTypes.func,
};

export default ActivityDataTable;
